import { apiRequest } from './http-service'

export interface Event {
  name: 'check_progress' | 'contact' | 'visit_page' | 'read_faq' | 'read_before_first_visit' | 'add_to_calendar',
  [key: string]: unknown;
}

export async function trackAddToCalendar() {
  return track({ name: 'add_to_calendar' })
}

export async function trackReadBeforeFirstVisit() {
  return track({ name: 'read_before_first_visit' })
}

export async function trackCheckProgress() {
  return track({ name: 'check_progress' })
}

export async function trackContact(channel: 'email' | 'phone', role: 'project_manager' | 'technician') {
  return track({ name: 'contact', channel, role })
}

export async function trackVisitPage(pageName: string) {
  return track({ name: 'visit_page', page_name: pageName })
}

export async function trackReadFaq(title: string) {
  return track({ name: 'read_faq', title })
}

async function track(event: Event) {
  return apiRequest('POST', 't', { data: event })
}
